import { render, staticRenderFns } from "./sumusrdata.vue?vue&type=template&id=5a8d8273&"
import script from "./sumusrdata.vue?vue&type=script&lang=js&"
export * from "./sumusrdata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports